import { notification } from 'antd';
import type { DeriveLayoutFeedbackHandlers } from '../AskAsperAgentic.types';

const FEEDBACK_THANKS_MESSAGE = 'Thanks for your feedback';

async function invokeWithThanksToast(fn: () => void | Promise<void>): Promise<void> {
    try {
        await Promise.resolve(fn());
        notification.success({ message: FEEDBACK_THANKS_MESSAGE });
    } catch {
        // Host may reject when the API fails; do not show a success toast.
    }
}

/**
 * Wraps messages-mode right-panel feedback handlers so a thank-you toast appears
 * after the handler completes successfully (including when it returns a Promise).
 */
export function wrapFeedbackHandlersWithSuccessToast(
    handlers: DeriveLayoutFeedbackHandlers | undefined,
): DeriveLayoutFeedbackHandlers | undefined {
    if (!handlers) return undefined;
    const { onRightPanelThumbsUp, onRightPanelThumbsDown, onRightPanelDislikeFeedbackSubmit } = handlers;
    if (!onRightPanelThumbsUp && !onRightPanelThumbsDown && !onRightPanelDislikeFeedbackSubmit) {
        return undefined;
    }
    return {
        onRightPanelThumbsUp: onRightPanelThumbsUp
            ? (payload) => {
                  void invokeWithThanksToast(() => onRightPanelThumbsUp(payload));
              }
            : undefined,
        onRightPanelThumbsDown: onRightPanelThumbsDown
            ? (payload) => {
                  void invokeWithThanksToast(() => onRightPanelThumbsDown(payload));
              }
            : undefined,
        onRightPanelDislikeFeedbackSubmit: onRightPanelDislikeFeedbackSubmit
            ? (payload) => {
                  void invokeWithThanksToast(() => onRightPanelDislikeFeedbackSubmit(payload));
              }
            : undefined,
    };
}
